
import { Component, Prop, Emit, Vue } from 'vue-property-decorator'

@Component({})
export default class FormDialog extends Vue {
  @Prop({ default: false })
  model!: boolean

  @Prop({ default: '' })
  title!: string

  @Emit()
  save () {
  }

  @Emit()
  cancel () {
  }
}
